var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7E46E310-B464-4E2A-8C9F-AD59D529782D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 59,
    cy: 59,
    r: 59
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MVP---Clinician",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "REGISTER",
    transform: "translate(-623.000000, -208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(479.000000, 133.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-picture",
    transform: "translate(145.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    stroke: "#1D1C1C",
    strokeWidth: 0.3,
    fill: "#F9F9FB",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#36C2B4",
    mask: "url(#mask-2)",
    cx: 59,
    cy: 57,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#36C2B4",
    mask: "url(#mask-2)",
    cx: 58.5,
    cy: 109.5,
    r: 27.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "UI-/-circle_button_icon-/-camera",
    mask: "url(#mask-2)",
    fill: "#1D1C1C",
    fillRule: "nonzero",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.000000, 50.000000)",
    id: "camera_white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2890625,2.56640625 C23.2265625,2.56640625 24,3.33984375 24,4.2890625 L24,16.2890625 C24,17.2265625 23.2265625,18 22.2890625,18 L1.7109375,18 C0.76171875,18 0,17.2265625 0,16.2890625 L0,4.2890625 C0,3.33984375 0.76171875,2.56640625 1.7109375,2.56640625 L5.14453125,2.56640625 C6.85546875,2.56640625 7.7109375,0 9.43359375,0 L14.5664062,0 C16.2890625,0 17.1445312,2.56640625 18.8554688,2.56640625 L22.2890625,2.56640625 Z M23.1445312,16.2890625 L23.1445312,4.2890625 C23.1445312,3.80859375 22.7578125,3.421875 22.2890625,3.421875 L19.0546875,3.421875 C16.8515625,3.421875 15.9609375,0.85546875 14.6484375,0.85546875 L9.43359375,0.85546875 C8.14453125,0.85546875 7.2890625,3.421875 5.14453125,3.421875 L1.7109375,3.421875 C1.2421875,3.421875 0.85546875,3.80859375 0.85546875,4.2890625 L0.85546875,16.2890625 C0.85546875,16.7578125 1.2421875,17.1445312 1.7109375,17.1445312 L22.2890625,17.1445312 C22.7578125,17.1445312 23.1445312,16.7578125 23.1445312,16.2890625 Z M12,4.2890625 C14.8359375,4.2890625 17.1445312,6.5859375 17.1445312,9.421875 C17.1445312,12.2695312 14.8359375,14.5664062 12,14.5664062 C9.1640625,14.5664062 6.85546875,12.2695312 6.85546875,9.421875 C6.85546875,6.5859375 9.1640625,4.2890625 12,4.2890625 Z M18.8554688,4.7109375 C19.3359375,4.7109375 19.7109375,5.09765625 19.7109375,5.56640625 C19.7109375,6.046875 19.3359375,6.421875 18.8554688,6.421875 C18.3867188,6.421875 18,6.046875 18,5.56640625 C18,5.09765625 18.3867188,4.7109375 18.8554688,4.7109375 Z M12,13.7109375 C14.3671875,13.7109375 16.2890625,11.7890625 16.2890625,9.421875 C16.2890625,7.0546875 14.3671875,5.14453125 12,5.14453125 C9.6328125,5.14453125 7.7109375,7.0546875 7.7109375,9.421875 C7.7109375,11.7890625 9.6328125,13.7109375 12,13.7109375 Z M12,6 C13.8984375,6 15.4335938,7.53515625 15.4335938,9.421875 C15.4335938,11.3203125 13.8984375,12.8554688 12,12.8554688 C10.1015625,12.8554688 8.56640625,11.3203125 8.56640625,9.421875 C8.56640625,7.53515625 10.1015625,6 12,6 Z M12,12 C13.4179688,12 14.5664062,10.8515625 14.5664062,9.421875 C14.5664062,8.00390625 13.4179688,6.85546875 12,6.85546875 C10.5820312,6.85546875 9.43359375,8.00390625 9.43359375,9.421875 C9.43359375,10.8515625 10.5820312,12 12,12 Z"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.750cc90caf68d190ab1ca20f086f2c7c.svg";
export { ForwardRef as ReactComponent };